import { useState } from 'react';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    data.append('email', email);

    try {
      await fetch('https://readdy.ai/api/form/d6nv6d930mftb86r3ba0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-24 px-8 bg-[#F5F0EB]">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="inline-block bg-white text-[#FF6B35] text-xs uppercase tracking-widest px-5 py-2 rounded-full mb-6 font-semibold">
              Get Started
            </span>
            <h2
              className="text-5xl font-bold text-black mb-5 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Ready to Transform Your Content?
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Join hundreds of real estate agents who are posting consistently, building their brand, and attracting more clients — without the stress.
            </p>
            <div className="flex flex-col gap-3">
              {[
                'Instant digital download',
                'Fully editable Canva templates',
                '30 days of content, done for you',
                'One-time purchase, use forever',
              ].map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center bg-[#FF6B35] rounded-full flex-shrink-0">
                    <i className="ri-check-line text-white text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="bg-white rounded-3xl p-10 shadow-sm">
            <h3 className="text-2xl font-bold text-black mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Get Notified at Launch
            </h3>
            <p className="text-sm text-gray-500 mb-8">
              Drop your email and be the first to know when the full pack is available — plus get an exclusive early-bird discount.
            </p>

            {submitted ? (
              <div className="text-center py-8">
                <div className="w-14 h-14 flex items-center justify-center bg-[#FFF0EA] rounded-full mx-auto mb-4">
                  <i className="ri-check-double-line text-3xl text-[#FF6B35]"></i>
                </div>
                <p className="text-black font-semibold text-lg mb-1">You're on the list!</p>
                <p className="text-sm text-gray-500">We'll reach out as soon as the templates are live.</p>
              </div>
            ) : (
              <form
                data-readdy-form
                id="newsletter-form"
                onSubmit={handleSubmit}
                className="flex flex-col gap-4"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  className="w-full px-5 py-4 rounded-xl border border-gray-200 focus:outline-none focus:border-[#FF6B35] text-sm text-black placeholder-gray-400"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#FF6B35] text-white py-4 rounded-xl font-medium hover:bg-[#e85d2a] transition-colors whitespace-nowrap cursor-pointer text-sm uppercase tracking-wider disabled:opacity-60"
                >
                  {loading ? 'Sending...' : 'Notify Me'}
                </button>
                <p className="text-xs text-gray-400 text-center">No spam. Unsubscribe anytime.</p>
              </form>
            )}

            <div className="mt-8 pt-8 border-t border-gray-100 text-center">
              <p className="text-xs text-gray-400 mb-2">Have questions?</p>
              <a
                href="mailto:hello@contentkit.com"
                className="text-sm text-[#FF6B35] font-medium hover:underline cursor-pointer"
              >
                hello@contentkit.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
